import { CanDeactivateFn } from '@angular/router';
import StudioEditorComponent from '@studio/components/editor/studio-editor.component';

export const studioUnsavedChangesGuard: CanDeactivateFn<StudioEditorComponent> = (component) => {
  return component.canDeactivate();
};
